import React, { useEffect, useContext } from "react";

import GlobalContext from "../../context/GlobalContext";
import NextSectionButton from "../NextSectionButton";

const themeConfigDefault = {
  headerDark: false,
  bodyDark: false,
  footerDark: false,
};

const PageWrapper = ({
  children,
  darkTheme = false,
  themeConfig = null,
  enableNextSection = true,
}) => {
  const gContext = useContext(GlobalContext);

  useEffect(() => {
    if (darkTheme) {
      gContext.changeTheme({
        headerDark: true,
        bodyDark: true,
        footerDark: true,
      });
    } else {
      gContext.changeTheme({ ...themeConfigDefault, ...themeConfig });
    }
  }, []);

  return (
    <>
      {children}
      {enableNextSection && <NextSectionButton />}
    </>
  );
};

export default PageWrapper;
